export class ConfirmDialogController {
  public static $inject = ['$mdDialog', 'title', 'variables', '$translate', 'content', 'okText', 'cancelText', '$sce'];
  public title: string;
  public message: string;
  public okText: string;
  public cancelText: string;
  public vm: ConfirmDialogController;

  constructor(
    private $mdDialog: ng.material.IDialogService, title: string, variables, $translate: ng.translate.ITranslateService,
    content: string, okText: string, cancelText: string, $sce: ng.ISCEService) {
    this.title = $translate.instant(title, variables);
    this.message = $sce.trustAsHtml($translate.instant(content, variables));
    this.okText = okText === undefined ? $translate.instant('DIALOG_COMMON.YES') : $translate.instant(okText);
    this.cancelText = cancelText === undefined ? $translate.instant('DIALOG_COMMON.NO') : $translate.instant(cancelText);
  }

  public ok = () => {
    this.$mdDialog.hide();
  }

  public cancel = () => {
    this.$mdDialog.cancel();
  }
}